<p>add-product-model-popup works!</p>
